import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login/login.vue'
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            name: '权限',
        },
        component: login,
        // children: [
        //   {
        //     path: 'customer',
        //     name: 'Customer',
        //     component: () => import(/* webpackChunkName: "Customer" */ '../views/Customer.vue')
        //   },
        // ]
    },
    {
        path: '/sessionList',
        name: 'sessionList',
        meta: {
            name: '会话',
            keepAlive: true,
        },
        component: () => import('_v/iM/sessionList.vue')
    },
    {
        path: '/myAssignment',
        name: 'myAssignment',
        meta: {
            name: '他人给我',
            keepAlive: true,
        },
        component: () => import('_v/iM/myAssignment.vue')
    },
    {
        path: '/chatIndex',
        name: 'chatIndex',
        meta: {
            name: '聊天'
        },
        component: () => import('_v/iM/chatIndex.vue')
    },
    {
        path: '/contentPage',
        name: 'contentPage',
        meta: {
            name: '内容库'
        },
        component: () => import('_v/iM/contentPage.vue')
    },
    {
        path: '/wordsPage',
        name: 'wordsPage',
        meta: {
            name: '话术库'
        },
        component: () => import('_v/iM/wordsPage.vue')
    },
    {
        path: '/chatContentPage',
        name: 'chatContentPage',
        meta: {
            name: '聊天页内容库'
        },
        component: () => import('_v/chatToolBar/contentPage.vue')
    },
    {
        path: '/staffContentPage',
        name: 'staffContentPage',
        meta: {
            name: '侧边栏话术库'
        },
        component: () => import('_v/chatToolBar/staffPage.vue')
    },
    {
        path: '/chatRemind',
        name: 'chatRemind',
        meta: {
            name: '消息提醒'
        },
        component: () => import('_v/chatToolBar/chatRemind.vue')
    },
    {
        path: '/adminList',
        name: 'adminList',
        meta: {
            name: '商家列表'
        },
        component: () => import('_v/login/adminList.vue')
    },
    {
        path: '/samrtSendOrder',
        name: 'samrtSendOrder',
        meta: {
            name: '智能派单'
        },
        component: () => import('_v/chatToolBar/samrtSendOrder.vue')
    },
    {
        path: '/selectcustomer',
        name: 'selectcustomer',
        meta: {
            name: '选择客户'
        },
        component: () => import('_v/chatToolBar/selectcustomer.vue')
    },
    // {
    //   path: '/groupCalendar',
    //   name: 'groupCalendar',
    //   meta:{
    //     name:'群日历'
    //   },
    //   component: () => import(/* webpackChunkName: "Loca" */ '../views/groupCalendar/groupCalendar.vue')
    // },
]
// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
